import { memo, useEffect } from 'react';

import { BUSINESS_PLAN_TYPES } from 'constants/businessPlan';
import { PDF_SECTIONS } from 'PDF/constants/sections';
import { prepareSectionId } from 'PDF/helpers/pdfMapping';
import { IPdfPageProps } from 'PDF/types/pdf';
import { useBusinessToolStore } from 'store/useBusinessToolStore';
import { getBusinessPlanChapters, getBusinessPlanType } from 'store/useBusinessToolStore/selectors';

import { useExamplePreview } from 'hooks/useExamplePreview';

import { getFinancialInformation, getFinancingNeeds, getMagazineItems } from './mapping';

export const Summary = memo(({ saveSectionProps, sectionPicture }: IPdfPageProps) => {
  const businessPlanChapters = useBusinessToolStore(getBusinessPlanChapters);
  const businessPlanType = useBusinessToolStore(getBusinessPlanType);
  const { isExamplePage } = useExamplePreview();
  const isInvestors = businessPlanType === BUSINESS_PLAN_TYPES.FOR_INVESTORS;

  const magazineItems = getMagazineItems(businessPlanChapters, isInvestors, isExamplePage);
  const financialInfo = getFinancialInformation(businessPlanChapters, businessPlanType, isExamplePage);
  const financingNeedsInfo = getFinancingNeeds(businessPlanChapters, isInvestors, isExamplePage);

  useEffect(() => {
    if (sectionPicture) {
      saveSectionProps(prepareSectionId(businessPlanType, PDF_SECTIONS.SECTION_SUMMARY), {
        magazineItems,
        data: {
          financialInfo,
          financingNeedsInfo,
        },
      });
    }
  }, [sectionPicture]);

  return null;
});
